import { render } from "./LeftDblArrow.vue?vue&type=template&id=ee846a02"
import script from "./LeftDblArrow.vue?vue&type=script&lang=js"
export * from "./LeftDblArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__